import React, { useState, useEffect } from 'react';
import { message, Modal } from 'antd';

import { hasIsAmplifyDefaultSelection } from '../../../../../core/utils/orgSettings';
import { DeleteOutlined, CloseOutlined } from '@ant-design/icons';
import TargetingLocationAudiencesList from './TargetingLocationAudiencesList';

export default function TargetingLocationAudiences({
  toolbarContainer,
  deleteAudienceLocation,
  style,
  targetingAudiences,
  title,
  setAudienceAmplifyDefault,
  amplify,
}) {
  const [selectedRows, setSelectedRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [filteredAudiences, setFilteredAudiences] = useState([]);

  const handleDeleteAudienceLocation = () => {
    if (hasIsAmplifyDefaultSelection(selectedRows)) {
      return message.error(
        "One of the selection is an Amplify Default and can't be deleted. Please update the selection and try again."
      );
    }
    deleteAudienceLocation(selectedRows);
  };

  const handleOk = () => {
    handleDeleteAudienceLocation(selectedRows);
    setSelectedRows([]);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleClearSelection = () => {
    setSelectedRows([]);
  };

  useEffect(() => {
    if (targetingAudiences && targetingAudiences.length) {
      setFilteredAudiences(
        targetingAudiences.filter((audience) => audience.orgs && audience.orgs.length === 1)
      );
    }
  }, [targetingAudiences]);

  const hasSelection = selectedRows.length > 0;

  return (
    <div className="targeting-audience">
      {open && hasSelection && (
        <Modal
          title="Confirm Action"
          visible={open}
          onOk={handleOk}
          onCancel={handleCancel}
          wrapClassName="targeting-root"
        >
          <p>Are you sure you want to delete ({selectedRows.length}) audience(s)?</p>
        </Modal>
      )}

      {/* ─── Selection alert bar (matches Addresses tab) ────────── */}
      {hasSelection && (
        <div className="targeting-selection-alert" role="status" aria-live="polite">
          <div className="targeting-selection-alert__info">
            <span className="targeting-selection-alert__count">{selectedRows.length}</span>
            <span className="targeting-selection-alert__text">
              audience{selectedRows.length !== 1 ? 's' : ''} selected
            </span>
          </div>
          <div className="targeting-selection-alert__actions">
            <button
              type="button"
              className="targeting-selection-alert__link targeting-selection-alert__link--danger"
              onClick={() => setOpen(true)}
            >
              <DeleteOutlined className="targeting-selection-alert__link-icon" />
              Delete
            </button>
            <button
              type="button"
              className="targeting-selection-alert__close"
              onClick={handleClearSelection}
              aria-label="Clear selection"
            >
              <CloseOutlined />
            </button>
          </div>
        </div>
      )}

      {/* Content */}
      <div className="targeting-audience__content">
        <TargetingLocationAudiencesList
          toolbarContainer={toolbarContainer}
          setAudienceAmplifyDefault={setAudienceAmplifyDefault}
          targetingAudiences={filteredAudiences}
          setSelectedRows={setSelectedRows}
          amplify={amplify}
        />
      </div>
    </div>
  );
}
